module.exports = __webpack_public_path__ + "static/assets/8f303509bdecaa73e6ff2a5fbb909b44.png";